/*
  Endeca control class for the search page endeca instance.

*/

var site = site || {};
(function ($) {
  site.endeca = site.endeca || {};
  site.endeca.instances = site.endeca.instances || {};
  site.endeca.instances.search = site.endeca.instances.search || {};

  site.endeca.instances.search.control = site.endeca.generic.Class.create(site.endeca.control, {
    initialize: function(args) {
      this._super(args);

      if (jQuery.address) {
        var that = this;
        jQuery.address.bind('change', that, function(event) {
          that.search({ queryString: $H(event.parameters).toQueryString() });

          // IE has issues with jQuery Address' initialize because of conflicts with iframes included on the page
          // The following will search unless it has already searched.
          window.setTimeout(function() {
            if (!that.hasSearched) {
              that.search({ queryString: $H(event.parameters).getQueryString() });
            }
          }, 100);
        });
      } else {
        this.search();
      }
    },

    searchCompleted: function() {
      this._super();

      if (this.meta && this.meta.searchInfo && this.meta.searchInfo.didYouMean && !this.searchTerm.match(/\*/)) {
        this.dym = this.meta.searchInfo.didYouMean;
      } else {
        this.meta.searchInfo.didYouMean = this.dym;
        this.dym = [];
      }

      this.results.products.resultData = this.catalogs.product.resultList;
      this.results.products.summaryResultData = this.meta.searchInfo;
      this.results.products.displayResults();
      this.results.products.show();

      if (this.results.products.resultData.length) {
        this.hasResults = true;
        var $invStatusLists = $('.js-inv-status-list');
        $invStatusLists.each(function() {
          var invStatusList = site.productView.InvStatusList($(this));
        });

        var productIds = site.productView.collectProductIds();
        if (productIds.length > 0) {
          site.productView.loadL2Data(productIds);
        }
      } else {
        this.results.products.hide();
      }

  	  this.results.pagination.resultData = this.meta.pagination;
  	  // @todo might need logic here
  	  //console.log(this.results.pagination.resultData);
  	  this.results.pagination.displayResults();
  	  this.results.pagination.show();

      if (!this.wildcardSearch) {
        this.results.content.contentzones = this.configuration.contentzones;
        this.results.content.resultData = this.meta.supplementalContent;
        this.results.content.displayResults();

        if (!jQuery.isEmptyObject(this.results.content.resultData)) {
          this.meta.processSearchInfo({ totalContentRecords: this.results.content.totalResults });
          //this.results.content.show();
          if (this.results.content.hasSoloResults) {
            this.hasResults = true;
          }
        } else {
          this.results.content.hide();
        }
      }

      this.results.refinements.resultData = this.meta.dimensions.refinements || [];
      this.results.refinements.displayResults();
      this.results.refinements.show();

  	  if (this.meta.dimensions.breadcrumbs) {
        this.results.breadcrumbs.resultData = this.meta.dimensions.breadcrumbs;
        this.results.breadcrumbs.displayResults();
        this.results.breadcrumbs.show();
        this.results.refinements.openAccordion();
      } else {
        this.results.breadcrumbs.hide();
      }

      if (!this.meta.dimensions.breadcrumbs && !this.meta.dimensions.refinements) {
      	this.results.refinements.hide();
      }

      this.results.summary.resultData = jQuery.extend(this.meta.searchInfo, { breadcrumbs: this.meta.dimensions.breadcrumbs });
      this.results.summary.hasResults = this.hasResults;
      this.results.summary.displayResult();

  	  this.displayResults();

      //even out rows
      //var $parentNode = (this.results.bestsellers.resultData.length > 0) ? this.results.bestsellers.parentNode : this.results.products.parentNode;
      var $parentNode = $('#bestseller-results').is(':visible') ? this.results.bestsellers.parentNode : this.results.products.parentNode;
      //var $results = $('.result', $parentNode);
      this.equalRowHeightInit($parentNode);
      var that = this;
      $(window).resize(function() {
        that.equalRowHeight($parentNode);
      });

      var $searchSummary = $('.js-search-summary, .js-search-summary-dym, .js-search-summary-ac', '.js-search-summary');
      $searchSummary.each(function() {
        if ($(this).length && $(this).html()) {
          $(this).html(_.unescape($(this).html()));
        } else {
          $(this).next().removeClass('hidden');
        }
      });

      // Adding Quickshop toggle feature [APACFECX-475]
      site.productView.mobilesearchRebuild(this.results.products.resultData);

      //Down Price Updated for Sized Shaded Products
      var productIds = site.productView.collectProductIds();
      productIds.map(function(index) {
        var id = index;
        var priceNode = $('#product-' + id + ' .js-search-product-size');
        if (priceNode.length > 0) {
          var price2 = priceNode.attr('data-price2');
          var formattedPrice = priceNode.attr('data-formatted-price');
          var formattedPrice2 = priceNode.attr('data-formatted-price2');
          var price2Range = priceNode.attr('data-price2-range');
          var priceRange = priceNode.attr('data-price-range');
          var additionalAttributes = '';
          var additionalClasses = '';
          if (Drupal.settings.globals_variables.endeca_loyalty_prices_enabled) {
            var $nodeToReplace = priceNode.children(0);
            // pre-existing code overwrites the child... we need to preserve some of these attributes/classes for loyalty
            if ($nodeToReplace.length) {
              var currency = $nodeToReplace.data('currency-symbol');
              var prefix = $nodeToReplace.attr('loyalty-price-prefix');
              var discountable = $nodeToReplace.data('is-discountable');
              additionalClasses = $nodeToReplace.hasClass('js-price-loyalty') ? ' js-price-loyalty' : '';
              additionalAttributes += currency ? ' data-currency-symbol="' + currency + '"' : '';
              additionalAttributes += prefix ? ' loyalty-price-prefix="' + prefix + '"' : '';
              additionalAttributes += discountable ? ' data-is-discountable="' + discountable + '"' : '';
            }
          }

          if (priceNode.hasClass('price-range') && priceRange.match(/-/)) {
            if (price2Range !== '' && price2Range !== null && priceRange !== '' && priceRange !== null) {
              priceNode.html('<span class="product__price--non-sale text--bold">' + price2Range + '</span> <span class="product__price--sale text--bold">' + priceRange + '</span>');
            } else {
              priceNode.html('<span class="text--bold' + additionalClasses + '"' + additionalAttributes + '>' + priceRange + '</span>');
            }
          } else if (price2) {
            priceNode.html('<span class="product__price--non-sale text--bold">' + formattedPrice2 + '</span> <span class="product__price--sale text--bold">' + formattedPrice + '</span>');
          } else {
            priceNode.html('<span class="text--bold' + additionalClasses + '"' + additionalAttributes + '>' + formattedPrice + '</span> ');
          }
        }
      });
      jQuery(document).trigger('endeca.search.results.loaded', [ this ]);
    },

    showLoading: function() {
      if (this.results.products) {
        this.results.products.reset();
      }
      if (this.results.content) {
        this.results.content.reset();
      }
      this._super();
    },
    resultTest: 0,
    equalRowHeightInit: function(parentNode) {
      var that = this;
      //even out row height
      setTimeout(function() { // timeout to let fonts render - @font-face FOUT
        var $results = $('.result', parentNode);

        // retest for elements to show up
        var resultCheck;
        if ($results.length == 0 && !that.resultTest) {
          resultCheck = setTimeout(function() {
            if ($results.length == 0) {
              that.equalRowHeightInit(parentNode);
            }
          }, 1000);
          return false;
        } else {
          that.resultTest = 1;
          clearTimeout(resultCheck);
        }

        var rowCount = that.findRowCount($results);
        var rows = _.groupBy($results, function(element, index) {
          return Math.floor(index / rowCount);
        });
        rows = _.toArray(rows);
        for (var x in rows) {
          var row = rows[x];
          var maxProductHeight = Math.max.apply(null, $(row).map(function() {
            return $(this).height();
          }).get());
          $(row).height(maxProductHeight);
        }

        if ($('#bestseller-results').is(':visible')) {
          site.productView.mpp.init(that.results.bestsellers.resultData);
          if (that.results.bestsellers.resultData.length > 0) {
            site.productView.mobilesearchRebuild(that.results.bestsellers.resultData);
          }
        } else {
          site.productView.mpp.init(that.results.products.resultData);
        }
      }, 1000); // bestsellers takes a long time to load And for Preorder also.
    },
    equalRowHeight: function(parentNode) {
      var that = this;
      //even out row height
      var $results = $('.result', parentNode);
      $results.attr('style', '');
      var rowCount = that.findRowCount($results);
      var rows = _.groupBy($results, function(element, index) {
        return Math.floor(index / rowCount);
      });
      rows = _.toArray(rows);
      for (var x in rows) {
        var row = rows[x];
        var maxProductHeight = Math.max.apply(null, $(row).map(function() {
          return $(this).height();
        }).get());
        $(row).height(maxProductHeight);
      }
    },
    findRow: function(current) {
      // var $products = $('.mpp__product');
      // //find other two in row
      // var mppProductIndex = current.index();
      // var mppProductEq = mppProductIndex-1;
      // var mppProductInRow = mppProductIndex%3;
      // //console.log('mppProductIndex: ' + mppProductIndex + ' mod: ' + mppProductInRow);
      // var $mppProductRow = [];
      // if(mppProductInRow == 1){ //first
      //   // cur, + 1, + 2
      //   $mppProductRow.push($products.eq(mppProductEq));
      //   $mppProductRow.push($products.eq(mppProductEq+1));
      //   $mppProductRow.push($products.eq(mppProductEq+2));
      // }else if(mppProductInRow == 2){ //second
      //   // - 1, cur, + 1
      //   $mppProductRow.push($products.eq(mppProductEq-1));
      //   $mppProductRow.push($products.eq(mppProductEq));
      //   $mppProductRow.push($products.eq(mppProductEq+1));
      // }else if(mppProductInRow == 0){ //third
      //   // - 2, - 1, cur 
      //   $mppProductRow.push($products.eq(mppProductEq-2));
      //   $mppProductRow.push($products.eq(mppProductEq-1));
      //   $mppProductRow.push($products.eq(mppProductEq));
      // }
      // //console.log($mppProductRow);
      // return $mppProductRow;
    },
    findRowCount: function(list) {
      var $list = list;
      if ($list.length < 1) {
        return null;
      }
      var listInRow = 0;
      $($list).each(function() {
        if ($(this).prev().length > 0) {
          if ($(this).position().top != $(this).prev().position().top) {
            return false;
          }
          listInRow++;
        } else {
          listInRow++;
        }
      });
      return listInRow;
    },
  });
})(jQuery);

